module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei3.svg";